import React from "react";
import { Badge } from "../components/ui/badge";
import {
  POLARITY_LABELS_TR, POLARITY_COLORS,
  WAR_STANCE_LABELS_TR, WAR_STANCE_COLORS,
} from "../lib/constants";

function pill(color, label, testid) {
  return (
    <Badge
      variant="outline"
      data-testid={testid}
      className="rounded-sm font-mono text-[10px] uppercase tracking-[0.18em] px-2 py-0.5"
      style={{ color, borderColor: `${color}55`, background: `${color}14` }}
    >
      {label}
    </Badge>
  );
}

export function PolarityBadge({ polarity }) {
  if (!polarity) return null;
  return pill(POLARITY_COLORS[polarity] || "#9CA3AF",
              POLARITY_LABELS_TR[polarity] || polarity,
              `polarity-badge-${polarity}`);
}

export function WarStanceBadge({ stance }) {
  if (!stance) return null;
  return pill(WAR_STANCE_COLORS[stance] || "#9CA3AF",
              WAR_STANCE_LABELS_TR[stance] || stance,
              `warstance-badge-${stance}`);
}
